<div class="container">
    <main class="container eui-u-flex-justify-content-center">
        <div class="eui-u-flex eui-u-flex-justify-content-center eui-u-flex-column">
            <h1>{{ "page.support.title" | translate }}</h1>
            <p class="eui-u-sh-2 eui-u-p-2xl" [innerHTML]="'page.support.content' | translate"></p>
        </div>

        <form [formGroup]="form">
            <div class="row">
                <h1>{{ "page.support.caller" | translate }}</h1>
                <div class="col-md-6">
                    <div euiInputGroup>
                        <label euiRequired euiLabel for="firstName">{{
                            "page.support.firstName" | translate
                        }}</label>
                        <input
                            euiInputText
                            id="firstName"
                            type="text"
                            formControlName="firstName"
                            required
                            placeholder="{{ 'page.support.firstName' | translate }}"
                            (blur)="markControlTouched('firstName')"
                        />
                        @if (isControlInvalid("firstName")) {
                            <eui-feedback-message euiDanger>
                                <span [innerHTML]="getControlError('firstName')"></span>
                            </eui-feedback-message>
                        }
                    </div>
                    <div euiInputGroup>
                        <label euiRequired euiLabel for="email">{{
                            "page.support.email" | translate
                        }}</label>
                        <input
                            euiInputText
                            id="email"
                            type="email"
                            formControlName="email"
                            required
                            placeholder="{{ 'page.support.email' | translate }}"
                            (blur)="markControlTouched('email')"
                        />
                        @if (isControlInvalid("email")) {
                            <eui-feedback-message euiDanger>
                                <span [innerHTML]="getControlError('email')"></span>
                            </eui-feedback-message>
                        }
                    </div>

                    @if (showAffectedEmail) {
                        <div euiInputGroup>
                            <div class="eui-u-inline-flex">
                                <input
                                    euiInputCheckBox
                                    id="requestSomeoneElse"
                                    formControlName="requestSomeoneElse"
                                    (change)="markControlTouched('requestSomeoneElse')"
                                />
                                <label for="requestSomeoneElse">{{
                                    "page.support.requestingForSomeoneElse" | translate
                                }}</label>
                            </div>
                        </div>
                        <div euiInputGroup>
                            <label
                                euiLabel
                                [euiRequired]="isAffectedEmailRequired()"
                                for="affectedEmail"
                                >{{ "page.support.affectedUser" | translate }}</label
                            >
                            <input
                                euiInputText
                                id="affectedEmail"
                                type="email"
                                formControlName="affectedEmail"
                                [disabled]="!isAffectedEmailRequired()"
                                [required]="isAffectedEmailRequired()"
                                placeholder="{{ 'page.support.affectedUserEmail' | translate }}"
                                (blur)="markControlTouched('affectedEmail')"
                            />
                            @if (isControlInvalid("affectedEmail")) {
                                <eui-feedback-message euiDanger>
                                    <span [innerHTML]="getControlError('affectedEmail')"></span>
                                </eui-feedback-message>
                            }
                        </div>
                    }
                </div>
                <div class="col-md-6">
                    <div euiInputGroup>
                        <label euiRequired euiLabel for="lastName">{{
                            "page.support.lastName" | translate
                        }}</label>
                        <input
                            euiInputText
                            id="lastName"
                            type="text"
                            formControlName="lastName"
                            required
                            placeholder="{{ 'page.support.lastName' | translate }}"
                            (blur)="markControlTouched('lastName')"
                        />
                        @if (isControlInvalid("lastName")) {
                            <eui-feedback-message euiDanger>
                                <span [innerHTML]="getControlError('lastName')"></span>
                            </eui-feedback-message>
                        }
                    </div>
                </div>
            </div>
            <div class="row">
                <h1>{{ "page.support.topics" | translate }}</h1>
                <div class="col-md-6">
                    <div euiInputGroup>
                        <label euiRequired euiLabel for="select-topics">{{
                            "page.support.selectTopic" | translate
                        }}</label>
                        <select
                            euiSelect
                            id="select-topics"
                            formControlName="topic"
                            (change)="markControlTouched('topic')"
                        >
                            <option value="">
                                --
                                {{ "page.support.selectTopic" | translate }} --
                            </option>
                            @for (topic of topics(); track topic.value) {
                                <option [ngValue]="topic.value">
                                    {{ topic.label | translate }}
                                </option>
                            }
                        </select>
                        @if (isControlInvalid("topic")) {
                            <eui-feedback-message euiDanger>
                                <span [innerHTML]="getControlError('topic')"></span>
                            </eui-feedback-message>
                        }
                    </div>
                </div>
                <div class="col-md-6">
                    <div euiInputGroup>
                        <!-- Category Selection - Only visible after topic is selected -->
                        @if (categories().length > 0) {
                            <label euiRequired euiLabel for="select-categories">{{
                                "page.support.selectCategory" | translate
                            }}</label>
                            <select
                                euiSelect
                                id="select-categories"
                                formControlName="category"
                                (change)="markControlTouched('category')"
                            >
                                <option value="">
                                    --
                                    {{ "page.support.selectCategory" | translate }}
                                    --
                                </option>
                                @for (category of categories(); track category) {
                                    <option [ngValue]="category">
                                        {{ category.label | translate }}
                                    </option>
                                }
                            </select>
                            @if (isControlInvalid("category")) {
                                <eui-feedback-message euiDanger>
                                    <span [innerHTML]="getControlError('category')"></span>
                                </eui-feedback-message>
                            }
                        }
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- Dynamic Inputs Based on Selected Category -->
                @if (selectedInputs().length > 0) {
                    @for (input of selectedInputs(); track input.name) {
                        <div class="col-12 col-md-6 eui-u-display-flex eui-u-flex-column">
                            <div euiInputGroup class="eui-u-width-100">
                                <label
                                    [attr.for]="input.name"
                                    euiLabel
                                    [euiRequired]="input.required"
                                    >{{ input.labelKey | translate }}
                                </label>
                                @if (input.type === "date") {
                                    <eui-datepicker
                                        isDatetimepicker
                                        appDateTimeFormatEurope
                                        dateOutputFormat="DD-MM-YYYY HH:mm"
                                        [formControlName]="input.name"
                                    />
                                }

                                <!-- Text / Email Input -->
                                @if (input.type === "text") {
                                    <input
                                        euiInputText
                                        [maxlength]="input.maxLength"
                                        [id]="input.name"
                                        [type]="input.type"
                                        [formControlName]="input.name"
                                        [required]="input.required"
                                        [placeholder]="input.placeholderKey | translate"
                                        (blur)="markControlTouched(input.name)"
                                    />
                                }

                                <!-- Multiline Text -->
                                @if (input.type === "textarea") {
                                    <textarea
                                        euiTextArea
                                        [id]="input.name"
                                        [maxlength]="input.maxLength"
                                        [formControlName]="input.name"
                                        [required]="input.required"
                                        rows="4"
                                        [placeholder]="input.placeholderKey | translate"
                                        (blur)="markControlTouched(input.name)"
                                    ></textarea>
                                }

                                <!-- Select -->
                                @if (input.type === "select") {
                                    <select
                                        euiSelect
                                        [id]="input.name"
                                        [formControlName]="input.name"
                                        [required]="input.required"
                                        (change)="markControlTouched(input.name)"
                                    >
                                        <option value="">
                                            --
                                            {{ input.labelKey | translate }}
                                            --
                                        </option>
                                        @for (
                                            opt of input.options;
                                            track opt.value;
                                            let i = $index
                                        ) {
                                            <option [ngValue]="opt.value">
                                                {{ opt.labelKey ?? opt.label | translate }}
                                            </option>
                                        }
                                    </select>
                                }

                                <!-- File Attachment -->
                                @if (input.type === "file") {
                                    <eui-file-upload
                                        [formControlName]="input.name"
                                        [accept]="allowedFileTypes"
                                        [hasPreview]="false"
                                        [required]="input.required"
                                        (change)="markControlTouched(input.name)"
                                    >
                                    </eui-file-upload>
                                }

                                @if (isControlInvalid(input.name)) {
                                    <eui-feedback-message euiDanger>
                                        <span [innerHTML]="getControlError(input.name)"></span>
                                    </eui-feedback-message>
                                }
                            </div>
                        </div>
                    }
                    @if (selectedCategoryLinks().length > 0) {
                        <div class="col-md-6 eui-u-inline-flex">
                            <div class="col-md-6">
                                <h3>
                                    {{ "page.support.link.faq.title" | translate }}
                                </h3>
                                @for (link of selectedCategoryLinks(); track link.url) {
                                    <p class="eui-u-sh-2 eui-u-p-s eui-u-text-center">
                                        <a
                                            [href]="link.url"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style="text-decoration: underline; display: block"
                                        >
                                            {{ link.labelKey | translate }}
                                        </a>
                                    </p>
                                }
                            </div>
                        </div>
                    }
                }
            </div>
            <div class="col-12 col-lg-5 col-xl-3 eui-u-sh-2">
                <app-textual-captcha></app-textual-captcha>
            </div>
            <button
                euiButton
                euiVariant="primary"
                type="submit"
                (click)="submit()"
                [disabled]="!isFormValidWithoutCaptcha() || !hasCaptchaAnswer()"
            >
                {{ "actions.submit" | translate }}
            </button>
        </form>
    </main>
</div>

<eui-dialog
    #topicWarningDialog
    [title]="topicWarningMessage()?.titleKey ?? '' | translate"
    acceptLabel="Close"
    [hasDismissButton]="false"
>
    @if (topicWarningMessage()) {
        <p>{{ topicWarningMessage()!.contentKey | translate }}</p>
    }
</eui-dialog>
